window.onload = function(){
	resetPrice();
	var linkmsg=document.getElementById("linkmsg");
	linkmsg.style.visibility="visible";
	linkmsg.innerHTML="カラーを選択してください";
	document.getElementById("opmsg").innerHTML = "<p> </p>";
    opmsg.style.visibility="hidden";
}
//画像変更
function changeImg(){
showimg1();
resetPrice();
var intW=document.getElementById("haba").value;
var intH=document.getElementById("height").value;
var idLeg = document.getElementsByName("legtype") ;
var i=0;
var intLeg = "";
for ( intLeg="", i=idLeg.length; i--; ) {
  if ( idLeg[i].checked ) {
    intLeg = idLeg[i].id;
      break;
  }
}
if (intH=="2nd"){
  switch(true){
    case (intW <= 90 && intLeg == "adj"):
      showimg1();
      break;
    case (intW >= 91 && intLeg == "adj"):
      showimg2();
      break;
    case (intW <= 90 && intLeg == "long"):
      showimg3();
      break;
    case (intW >= 91 && intLeg == "long"):
      showimg4();
      break;
      }
}else if (intH=="3rd"){
  switch(true){
    case (intW <= 90 && intLeg == "adj"):
      showimg5();
      break;
    case (intW >= 91 && intLeg == "adj"):
      showimg6();
      break;
    case (intW <= 90 && intLeg == "long"):
      showimg7();
      break;
    case (intW >= 91 && intLeg == "long"):
      showimg8();
      break;
  }
}else if(intH=="height-select"){
  document.getElementById("opmsg").innerHTML = "<span>段数を選んでください</span>";
  return false;
}
changeMsg();
}
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj90_2.gif?v=1643474291";
document.getElementById("opmsg").innerHTML = "<p>※高さ83cmとなります</p>";
opmsg.style.visibility="visible";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj120_2.gif?v=1643474492";
document.getElementById("opmsg").innerHTML = "<p>※高さ83cmとなります<br>※中央に仕切り板が1枚入ります</p>";
opmsg.style.visibility="visible";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj90_2.gif?v=1643474291";
document.getElementById("opmsg").innerHTML = "<p>※高さ98cmとなります</p>";
opmsg.style.visibility="visible";
}
function showimg4(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj120_2.gif?v=1643474492";
document.getElementById("opmsg").innerHTML = "<p>※高さ98cmとなります<br>※中央に仕切り板が1枚入ります</p>";
opmsg.style.visibility="visible";
}
function showimg5(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj90_3.gif?v=1643474460";
document.getElementById("opmsg").innerHTML = "<p>※高さ114.4cmとなります</p>";
opmsg.style.visibility="visible";
}
function showimg6(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfadj120_3.gif?v=1643474460";
document.getElementById("opmsg").innerHTML = "<p>※高さ114.4cmとなります<br>※中央に仕切り板が1枚入ります</p>";
opmsg.style.visibility="visible";
}
function showimg7(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfleg90_3.gif?v=1643474460";
document.getElementById("opmsg").innerHTML = "<p>※高さ129.5cmとなります</p>";
opmsg.style.visibility="visible";
}
function showimg8(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/1_sfleg120_3.gif?v=1643474587";
document.getElementById("opmsg").innerHTML = "<p>※高さ129.5cmとなります<br>※中央に仕切り板が1枚入ります</p>";
opmsg.style.visibility="visible";
}
// カラー
function checkBtn(){
  resetPrice();
  var idColor = document.getElementsByName( "colortype" ) ;
  var strColor = "";
  var i=0;
  for ( strColor="", i=idColor.length; i--; ) {
    if ( idColor[i].checked ) {
      strColor = idColor[i];
        break;
    }
  }
  var linkmsg=document.getElementById("linkmsg");
  var strErrmsg="";
  if(strColor=""){
    linkmsg.style.visibility="visible";
    strErrmsg="カラーを選択してください";
    document.getElementById("price").value="";
    document.frm_detail.checkbtn.disabled =true;
  }else{
    linkmsg.style.visibility="hidden";
    linkmsg.innerHTML="";
    document.getElementById("price").value="";
    document.frm_detail.checkbtn.disabled =false;
  }
  if(strErrmsg!=""){
  linkmsg.innerHTML=strErrmsg;
     }
}
//脚カラー
function legClear(){
  $(".choiceLeg").css({"backgroundColor":"#ccc","opacity":"0.4"});
  let input = document.getElementById("legNa");
  input.disabled = true;
  input = document.getElementById("legWh");
  input.disabled = true;
}
function ainoLeg(){
  var legType = document.getElementsByName("legtype");
  for ( checkType="", i=legType.length; i--; ) {
    if ( legType[i].checked ) {
      checkType = legType[i].value;
      break;
    }}
  if(checkType == "脚タイプ"){
  $(".choiceLeg").css({"backgroundColor":"#fafafa","opacity":"1"});
  let input = document.getElementById("legNa");
  input.disabled = false;
  input = document.getElementById("legWh");
  input.disabled = false;
  }else legClear();
}
function LegChange(){
  let ainoType = document.getElementsByName("colortype");
  for ( i=ainoType.length; i--; ) {
    if ( ainoType[i].checked ) {
      if(i<=7){legClear();}
      else if(i<=13){ainoLeg();}}
    }}
function choiceLeg(){
  resetPrice();
  var legColor = document.getElementsByName("legColor");
  var choiceLegColor ="(デフォルト)";
  for (choiceLegColor="(デフォルト)", i=legColor.length; i--; ) {
  if ( legColor[i].checked ) {
    choiceLegColor = legColor[i].value ;
      break;
  }
}}
//リセット
function resetPrice(){
	document.getElementById("price").value=""
	cart_price.innerHTML =""+" 円";
	cart_haba.innerHTML="";;
	cart_height.innerHTML="";
	cart_leg.innerHTML="";
	cart_color.innerHTML="";
	//linkmsg.style.visibility="hidden";	//190208追加
}


//リアルタイムメッセージ
function changeMsg(){
var strErr;
var intHaba=document.getElementById("haba").value;
  if(intHaba == ""){
    
  }else if (intHaba < 60){
  strErr="幅60cm未満";
  }else if (intHaba > 180){
  strErr="幅181cm以上";
}
if(strErr){
document.getElementById("opmsg").innerHTML = "<span>※"+strErr+"はオーダー不可です。</span>";
opmsg.style.visibility="visible";
return false;
}
}

const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,height,legtype,color){
this.url=url;this.haba=haba;this.height=height;this.legtype=legtype;this.color=color;}
function searchURL(strHaba,idHeight,strLeg,strColor){
var strErr;
var intHaba=document.getElementById("haba").value;
intHaba=parseInt(intHaba);

//幅チェック
if (intHaba < 60){
  strErr="幅60cm未満";
}else if (intHaba > 180){
  strErr="幅181cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}


//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
   if(strHaba.slice(1,2)=="9" && strHaba.slice(-1)!="0"){
    strHaba="200";
   }else{
    strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
    strHaba=parseInt(strHaba);
   }
  }
  break;
} 
//価格
strHaba=parseInt(strHaba);
var intH=document.getElementById("height").value;
var idLeg = document.getElementsByName( "legtype" ) ;
var i=0;
var intLeg = "";
var sellPrice;
for ( intLeg="", i=idLeg.length; i--; ) {
  if ( idLeg[i].checked ) {
    intLeg = idLeg[i].id;
      break;
  }
}
if(strHaba == 60){
  if(intH == "2nd" && intLeg == "adj"){
    sellPrice=29000;
  }else if(intH == "3rd" && intLeg == "adj"){
    sellPrice=35000;
  }else if(intH == "2nd" && intLeg == "long"){
    sellPrice=35000;
  }else if(intH == "3rd" && intLeg == "long"){
    sellPrice=43000;
  }
}else if(strHaba >= 70 && strHaba <= 90){
  if(intH == "2nd" && intLeg == "adj"){
    sellPrice=38000;
  }else if(intH == "3rd" && intLeg == "adj"){
    sellPrice=43000;
  }else if(intH == "2nd" && intLeg == "long"){
    sellPrice=43000;
  }else if(intH == "3rd" && intLeg == "long"){
    sellPrice=54000;
  }
}else if(strHaba >= 100 && strHaba <= 120){
  if(intH == "2nd" && intLeg == "adj"){
    sellPrice=47000;
  }else if(intH == "3rd" && intLeg == "adj"){
    sellPrice=59000;
  }else if(intH == "2nd" && intLeg == "long"){
    sellPrice=54000;
  }else if(intH == "3rd" && intLeg == "long"){
    sellPrice=64000;
  }
}else if(strHaba >= 130 && strHaba <= 150){
  if(intH == "2nd" && intLeg == "adj"){
    sellPrice=59000;
  }else if(intH == "3rd" && intLeg == "adj"){
    sellPrice=70000;
  }else if(intH == "2nd" && intLeg == "long"){
    sellPrice=63000;
  }else if(intH == "3rd" && intLeg == "long"){
    sellPrice=74000;
  }
}else if(strHaba >= 160 && strHaba <= 180){
  if(intH == "2nd" && intLeg == "adj"){
    sellPrice=67000;
  }else if(intH == "3rd" && intLeg == "adj"){
    sellPrice=79000;
  }else if(intH == "2nd" && intLeg == "long"){
    sellPrice=75000;
  }else if(intH == "3rd" && intLeg == "long"){
    sellPrice=85000;
  }
}
return sellPrice;
}
/*リストから商品URLを取得*/
function checkURL(strHaba,idHeight,typeLeg,strColor){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].height==idHeight && goods[i].legtype==typeLeg && goods[i].color==strColor){
return goods[i].url;}}
return false;
}
/*リストから価格を取得*/
function checkPrice(strHaba,idHeight,typeLeg,strColor){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].height==idHeight && goods[i].legtype==typeLeg && goods[i].color==strColor){
return goods[i].price;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 resetPrice();
	
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value="";

var strHaba=document.getElementById("haba").value;
var idHeight=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
var idLeg = document.getElementsByName( "legtype" ) ;
var strColor = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
    break;
 }
}
for ( var strLeg="", c=idLeg.length; c--; ) {
  if ( idLeg[c].checked ) {
    strLeg = idLeg[c].value;
    var typeLeg = idLeg[c].id;
      break;
  }
}
var strHeight="";
if(idHeight=="2nd"){
  strHeight="2"
}else if(idHeight=="3rd"){
  strHeight="3"  
}else if(idHeight=="height-select"){
alert("段数を選択してください");
return false;
}

  var legColor = document.getElementsByName("legColor");
  var choiceLegColor ="(デフォルト)";
  if(strColor=="aino" && typeLeg=="long"){
    for (choiceLegColor="(デフォルト)", i=legColor.length; i--; ) {
      if ( legColor[i].checked ) {
        choiceLegColor = legColor[i].value ;
        break;
      }
    }
    if(strColor=="aino" && typeLeg=="long" && choiceLegColor =="(デフォルト)"){
      alert("本体がパステルカラーかつ脚タイプの場合は『脚カラー』を選択してください");
      return false;
    }
  }

if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strHeight+"段"
document.getElementById("choice3").value=strLeg+choiceLegColor
document.getElementById("choice4").value=valueColor

//商品ページの有無チェック
var comcode=checkURL(strHaba,idHeight,typeLeg,strColor);
if(!comcode==""){
  if(valueColor=="強化紙ブラックウッド" || valueColor=="強化紙ホワイト"){
    var target=document.getElementById("linkmsg");
    linkmsg.style.visibility="visible";
    target.innerHTML=valueColor+"は別注色のため金額が異なります。";
  }
  else {
  var target=document.getElementById("linkmsg");
  linkmsg.style.visibility="visible";
  target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
  return false;
  }
}
var url=searchURL(strHaba,idHeight,strLeg,strColor);

if(!url){
alert("幅を入力してください");
return false;
}


var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_height.innerHTML=strHeight;
 cart_leg.innerHTML=strLeg+choiceLegColor;
 cart_color.innerHTML=valueColor;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice5").value="見積もり金額："+url;
return false;
}


function checkText() {
	var choice1=document.frm.choice1.value;
	var choice2=document.frm.choice2.value;
	var choice3=document.frm.choice3.value;
	var choice4=document.frm.choice4.value;
	var choice5=document.frm.choice5.value;
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }
     return true;
}
goods = new Object();
goods[0] = new setGoods("0000a55293","60","2nd","long","wood");
goods[1] = new setGoods("0000a55299","90","2nd","long","wood");
goods[2] = new setGoods("0000a55305","120","2nd","long","wood");
goods[3] = new setGoods("0000a55311","150","2nd","long","wood");
goods[4] = new setGoods("0000a55317","180","2nd","long","wood");
goods[5] = new setGoods("0000a55323","60","3rd","long","wood");
goods[6] = new setGoods("0000a55329","90","3rd","long","wood");
goods[7] = new setGoods("0000a55335","120","3rd","long","wood");
goods[8] = new setGoods("0000a55341","150","3rd","long","wood");
goods[9] = new setGoods("0000a55347","180","3rd","long","wood");
goods[10] = new setGoods("0000a55353","60","2nd","adj","wood");
goods[11] = new setGoods("0000a55359","90","2nd","adj","wood");
goods[12] = new setGoods("0000a55365","120","2nd","adj","wood");
goods[13] = new setGoods("0000a55371","150","2nd","adj","wood");
goods[14] = new setGoods("0000a55377","180","2nd","adj","wood");
goods[15] = new setGoods("0000a55383","60","3rd","adj","wood");
goods[16] = new setGoods("0000a55389","90","3rd","adj","wood");
goods[17] = new setGoods("0000a55395","120","3rd","adj","wood");
goods[18] = new setGoods("0000a55401","150","3rd","adj","wood");
goods[19] = new setGoods("0000a55407","180","3rd","adj","wood");